import { Component, ViewChild, ElementRef, AfterViewInit } from '@angular/core';
import {FormControl} from '@angular/forms';
import {Observable} from 'rxjs';
import {map, startWith} from 'rxjs/operators';
import { DefaultEditor } from 'ng2-smart-table';

@Component({
  template: `
    <form class="example-form">
      <mat-form-field>
        <input #test
               type="text"
               placeholder="Enter or select a value"
               matInput
               [formControl]="myControl"
               [matAutocomplete]="auto"
               (click)="onClick.emit($event)"
               (keyup)="updateValue([test.value])"
               (keydown.enter)="onEdited.emit($event)"
               (keydown.esc)="onStopEditing.emit()">
        <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete">
          <mat-option *ngFor="let option of filteredOptions | async" [value]="option" (onSelectionChange)="updateValue(this.option)">
            {{option}}
          </mat-option>
        </mat-autocomplete>
      </mat-form-field>
    </form>
  `,
})

export class CustomAutoTextEditorComponent extends DefaultEditor implements AfterViewInit {
  @ViewChild('test', { static: false }) test: ElementRef;
  myControl = new FormControl();

  options: string[] = [];

  filteredOptions: Observable<string[]>;

  private _filter(value: string): string[] {
    const filterValue = value.toLowerCase();

    return this.options.filter(option => option.toLowerCase().indexOf(filterValue) === 0);
  }

  constructor() {
    super();

  }

  ngAfterViewInit() {
    switch (this.cell.getId()) {
      case 'description': {
        this.options = ['Home Loan', 'Car Loan', 'Investment Loan', 'Credit Card'];
        break;
      }
      case 'lender': {
        this.options = ['AMP', 'CBA', 'Westpac', 'ING Direct', 'NPBS', 'Greater', 'NAB', 'Citi Bank', 'GE Money'];
        break;
      }
    default: {
        console.log('Broken');
        break;
      }
    }
    this.filteredOptions = this.myControl.valueChanges
      .pipe(
        startWith(''),
        map(value => this._filter(value)
      )
    );

    if (this.cell.newValue !== '') {
      this.myControl.setValue(this.cell.newValue);
    }
  }

  updateValue(newValue) {
    this.cell.newValue = newValue;
  }

}



